import { breakpointsTailwind } from '@vueuse/core';

export const cvBreakpoints = breakpointsTailwind;
